import CatalogView from "./CatalogView";
import {
  GlobalOutlined,
  FileSearchOutlined,
  ClusterOutlined,
  SolutionOutlined,
  TagOutlined,
  BuildOutlined,
  ContactsOutlined,
  PhoneOutlined,
  ThunderboltOutlined,
  AuditOutlined,
} from "@ant-design/icons";

const iconStyle = { fontSize: 17, color: "#1677ff" };

export function CatalogNacionalidades() { 
  return <CatalogView tableName="cat_nacionalidades" title="Nacionalidades" icon={<GlobalOutlined style={iconStyle} />} />; 
}
export function CatalogObjetosSolicitud() { 
  return <CatalogView tableName="cat_objetossolicitud" title="Objetos de Solicitud" icon={<FileSearchOutlined style={iconStyle} />} />; 
}
export function CatalogScian() { 
  return <CatalogView tableName="cat_scian" title="SCIAN" icon={<ClusterOutlined style={iconStyle} />} />; 
}
export function CatalogTiposConcentracion() { 
  return <CatalogView tableName="cat_tiposconcentracion" title="Tipos de Concentración" icon={<SolutionOutlined style={iconStyle} />} />; 
}
export function CatalogTiposDato() { 
  return <CatalogView tableName="cat_tiposdato" title="Tipos de Dato" icon={<TagOutlined style={iconStyle} />} />; 
}
export function CatalogTiposInstalacion() { 
  return <CatalogView tableName="cat_tiposinstalacion" title="Tipos de Instalación" icon={<BuildOutlined style={iconStyle} />} />; 
}
export function CatalogTiposPersona() { 
  return <CatalogView tableName="cat_tipospersona" title="Tipos de Persona" icon={<ContactsOutlined style={iconStyle} />} />; 
}
export function CatalogTiposTelefono() { 
  return <CatalogView tableName="cat_tipostelefono" title="Tipos de Teléfono" icon={<PhoneOutlined style={iconStyle} />} />; 
}
export function CatalogTiposTension() { 
  return <CatalogView tableName="cat_tipostension" title="Tipos de Tensión" icon={<ThunderboltOutlined style={iconStyle} />} />; 
}
export function CatalogTiposVerificacion() { 
  return <CatalogView tableName="cat_tiposverificacion" title="Tipos de Verificación" icon={<AuditOutlined style={iconStyle} />} />; 
}
